import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  userInfo: {},
  roles: [],
  departmentInfo: {},
  UserEditAbility: [],
  userEditData: [],
  response: null,
  isFetching: false,
  isSuccess: false,
  isUserinfosuccess: false,
  isEditUserSuccess: false,
  isUserEditDataSucess: false,
  isUserEditAbilitySucess: false,
  isError: false,
  errorMessage: '',
};

export const editUser = createAsyncThunk(
  'users/edituser',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/user', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const editUserSlice = createSlice({
  name: 'edituser',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    getUserEditAbility: (state, { payload }) => {
      state.UserEditAbility = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUserEditAbilitySucess = true;
    },
    getUserInfo: (state, { payload }) => {
      state.userInfo = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUserinfosuccess = true;
    },
    isUserInfo: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isEditUserSuccess = false;
      state.isUserinfosuccess = false;
    },
    getRolesByUserType: (state, { payload }) => {
      state.roles = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = true;
      state.isUserinfosuccess = false;
    },
    getDepartmentInfo: (state, { payload }) => {
      state.departmentInfo = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = true;
      state.isUserinfosuccess = false;
    },
    editForUserAbilityCase: (state, { payload }) => {
      state.userEditData = payload.data;
      state.isUserEditDataSucess = true;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = payload.message;
    },
    clearEditForUserAbilityCase: (state, { payload }) => {
      state.userEditData = [];
      state.isUserEditDataSucess = false;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
    },
    clearStateEditUser: (state, { payload }) => {
      state.roles = [];
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isUserinfosuccess = false;
      state.UserEditAbility = [];
      state.isUserEditAbilitySucess = false;
      state.isUserEditDataSucess = false;
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isEditUserSuccess = false;
      state.isUserinfosuccess = false;
    },
    clearOnlyUserEditAbility: (state, { payload }) => {
      state.UserEditAbility = [];
      state.isUserEditAbilitySucess = false;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
    },

  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [editUser.fulfilled]: (state, { payload }) => {
      // console.log(payload)
      state.response = payload;
      state.isFetching = false;
      state.isEditUserSuccess = true;
      state.isUserinfosuccess = false;
      return state;
    },
    [editUser.pending]: (state) => {
      state.isFetching = true;
    },
    [editUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isEditUserSuccess = false;
      state.isUserinfosuccess = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearOnlyUserEditAbility, clearEditForUserAbilityCase, editForUserAbilityCase, clearStateEditUser, isSuccess, getRolesByUserType, getDepartmentInfo, getUserInfo, getUserEditAbility, isUserInfo } = editUserSlice.actions;

export const getUserEditAbilityAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  let response = await axios({
    url: '/api/user/editAbility/' + udata,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  //console.log(data.data)
  dispatch(getUserEditAbility(data));
};



export const editForUserAbilityCaseAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.patch('/api/user/editAbility', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  //console.log(data.data)
  dispatch(editForUserAbilityCase(data));
};

export const getUserInfoAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/user/detailed/' + udata,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  console.log(data.data,"data")
  dispatch(getUserInfo(data));
};

export const getRolesByUserTypeAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/userRoles/forAssigning/?userType=' + udata,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  //console.log(data.data)
  dispatch(getRolesByUserType(data));
};

export const getDepartmentInfoAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/departments/forAssigning/Chief of Air Staff',
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  //console.log(data.data)
  dispatch(getDepartmentInfo(data));
};

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateEditUser());
  }
}

export function clearStateSuccess() {

  return async (dispatch) => {
    dispatch(isSuccess());
  }
}

export function clearStateUserSuccess() {

  return async (dispatch) => {
    dispatch(isUserInfo());
  }
}

export function clearOnlyUserEditAbilitySuccess() {

  return async (dispatch) => {
    dispatch(clearOnlyUserEditAbility());
  }
}

export function clearEditForUserAbilityCaseSuccess() {

  return async (dispatch) => {
    dispatch(clearEditForUserAbilityCase());
  }
}

export const editUserSelector = (state) => state.edituser;

export default editUserSlice.reducer;
